import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createSession, sendInputData, sendDSData, sendSessionMetaData, sendSessionOption,
		    sendKeyContainer, createDS, getDSResult, deleteSession, sendTokenPath } from '../actions/api'
import { setInputDescription, clearInputFileForDS, clearInputDescription, setInputTextForDS, clearInputTextForDS, setInputTextForDSUintArr,
			setDSData, clearDSData, setPrevisionDsFile, clearPrevisionDsFile, setDSEncodingType, setInputTextForDSDescription,
			setDSDataBase64, clearDSDataBase64, clearDSInputTextDescription, setPrevisionDsText, clearPrevisionDsText } from '../actions/localStates'
import { StringToUTF16LEArray, fromByteArray, StringToArray, toByteArray } from '../actions/stringEncodersFuncs'
import i18next from 'i18next'


class CreateTextDSContainer extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
      		uuid: null,
      		isLoading: false,
      		blobData: null,
      		inputTextValue: "",
      		responseTextValue: ""
	    }

	    this.textEncodingHendler = this.textEncodingHendler.bind(this)
	    this.textInputHendler = this.textInputHendler.bind(this)
	    this.handleDescriptionChange = this.handleDescriptionChange.bind(this)
	    this.handlePrevisionChange = this.handlePrevisionChange.bind(this)
	}

	componentDidMount() {
		
	}

	textEncodingHendler(e) {
		this.props.actions.setDSEncodingType(e.target.value)
	}

	handleDescriptionChange(e) {
		this.props.actions.setInputTextForDSDescription(e.target.value)
		this.props.actions.clearDSDataBase64()
	}

	textInputHendler(e) {
		this.props.actions.setInputTextForDS(e.target.value)
		this.props.actions.clearDSDataBase64()
	}

	handlePrevisionChange(e) {
		this.props.actions.setPrevisionDsText(e.target.value)
		this.props.actions.clearDSDataBase64()
	}

	cleanUpForm() {
		this.setState({inputTextValue: ""})
		this.setState({responseTextValue: ""})
		this.props.actions.clearInputTextForDS()
		this.props.actions.clearDSInputTextDescription()
		this.props.actions.clearDSDataBase64()
		this.props.actions.clearPrevisionDsText()
	}

	createDS() {
		var _this = this;
		var arr

		this.props.createDSDefaultState.textEncoding === 'UTF-16LE'
			? arr = this.props.actions.StringToUTF16LEArray(this.props.createDSDefaultState.textForDS, false)
			: arr = this.props.actions.StringToArray(this.props.createDSDefaultState.textForDS, true)

		if (this.props.createDSDefaultState.previsionDsText.length > 0) {
			var arrToSend = this.props.actions.toByteArray(this.props.createDSDefaultState.previsionDsText);
        	var dsData = new Uint8Array(arrToSend)
		}

		var u8Arr = new Uint8Array(arr);
		this.props.actions.setInputTextForDSUintArr(u8Arr)

		this.setState({isLoading: true})
		this.props.actions.createSession(this.props.connectionStatus.baseUrl)
        .then((response) => {
          this.setState({uuid: response.ticketUuid})
          console.log(response);
          return this.props.defaultState.duplicateSign && this.props.defaultState.signatureType === "attached"
          		? this.props.actions.sendDSData(this.props.connectionStatus.baseUrl, this.state.uuid, dsData)
	            .then(() => {
					return this.props.actions.sendSessionOption(this.props.connectionStatus.baseUrl, this.state.uuid, this.props.defaultState)
			            .then(() => this.props.actions.createDS(this.props.connectionStatus.baseUrl, this.state.uuid))
			            .then(() => this.props.actions.getDSResult(this.props.connectionStatus.baseUrl, this.state.uuid))
			            .then((response) => {
			            		if (response !== null) {
		            			var reader = new FileReader();
				                reader.onload = function () {
				                    var arrayBuffer = reader.result;
				                    var uintArray = new Uint8Array(arrayBuffer);
				                    var b64String = _this.props.actions.fromByteArray(uintArray)
				                    _this.props.actions.setDSDataBase64(b64String)
				                }
				                reader.readAsArrayBuffer(response);
		                    	console.log(response)
		                    	alert(i18next.t("ds:dsResponseSuccess": "dsResponseSuccess"))
		            		} else {
		            			alert(i18next.t("ds:dsResponseFailed": "dsResponseFailed"))
		            		}
			            		this.setState({isLoading: false})
			                  })
			            .then(() => this.props.actions.deleteSession(this.props.connectionStatus.baseUrl, this.state.uuid))
			            .then(() => this.props.createDSDefaultState.dsData ? this.getBlobData() : null)
				}) : this.props.defaultState.duplicateSign && this.props.defaultState.signatureType === "detached"
				? this.props.actions.sendInputData(this.props.connectionStatus.baseUrl, this.state.uuid, this.props.createDSDefaultState.textForDSUint8Arr)
				.then(() => {
					return this.props.actions.sendDSData(this.props.connectionStatus.baseUrl, this.state.uuid, dsData)
					.then(() => this.props.actions.sendSessionMetaData(this.props.connectionStatus.baseUrl, this.state.uuid, this.props.createDSDefaultState.textForDSDescription)
		            .then(() => this.props.actions.sendSessionOption(this.props.connectionStatus.baseUrl, this.state.uuid, this.props.defaultState))
		            .then(() => this.props.actions.createDS(this.props.connectionStatus.baseUrl, this.state.uuid))
		            .then(() => this.props.actions.getDSResult(this.props.connectionStatus.baseUrl, this.state.uuid))
		            .then((response) => {
		            		if (response !== null) {
		            			var reader = new FileReader();
				                reader.onload = function () {
				                    var arrayBuffer = reader.result;
				                    var uintArray = new Uint8Array(arrayBuffer);
				                    var b64String = _this.props.actions.fromByteArray(uintArray)
				                    _this.props.actions.setDSDataBase64(b64String)
				                }
				                reader.readAsArrayBuffer(response);
		                    	console.log(response)
		                    	alert(i18next.t("ds:dsResponseSuccess": "dsResponseSuccess"))
		            		} else {
		            			alert(i18next.t("ds:dsResponseFailed": "dsResponseFailed"))
		            		}
		            		this.setState({isLoading: false})
		                  })
		            .then(() => this.props.actions.deleteSession(this.props.connectionStatus.baseUrl, this.state.uuid)))
		            .then(() => this.props.createDSDefaultState.dsData ? this.getBlobData() : null)
				}) : this.props.actions.sendInputData(this.props.connectionStatus.baseUrl, this.state.uuid, this.props.createDSDefaultState.textForDSUint8Arr)
				.then(() => {
					return this.props.actions.sendSessionMetaData(this.props.connectionStatus.baseUrl, this.state.uuid, this.props.createDSDefaultState.textForDSDescription)
					.then(() => this.props.actions.sendSessionOption(this.props.connectionStatus.baseUrl, this.state.uuid, this.props.defaultState))
		            .then(() => this.props.actions.createDS(this.props.connectionStatus.baseUrl, this.state.uuid))
		            .then(() => this.props.actions.getDSResult(this.props.connectionStatus.baseUrl, this.state.uuid))
		            .then((response) => {
		            		if (response !== null) {
		            			var reader = new FileReader();
				                reader.onload = function () {
				                    var arrayBuffer = reader.result;
				                    var uintArray = new Uint8Array(arrayBuffer);
				                    var b64String = _this.props.actions.fromByteArray(uintArray)
				                    _this.props.actions.setDSDataBase64(b64String)
				                }
				                reader.readAsArrayBuffer(response);
		                    	console.log(response)
		                    	alert(i18next.t("ds:dsResponseSuccess": "dsResponseSuccess"))
		            		} else {
		            			alert(i18next.t("ds:dsResponseFailed": "dsResponseFailed"))
		            		}
		            		this.setState({isLoading: false})
		                  })
		            .then(() => this.props.actions.deleteSession(this.props.connectionStatus.baseUrl, this.state.uuid))
				})
        })
	}

	render() {
		const isTextDSEnabled = this.props.defaultState.duplicateSign
			? this.props.createDSDefaultState.previsionDsText.length > 0
			: this.props.createDSDefaultState.textForDS.length > 0;
		return (
			<div>
				<div className="card">
					<div className="card-header">
						{i18next.t("textData": "textData")}
					</div>
					<div className="collapse show">
	                  	<div className="card-body">
		                    <div>
		                    	<div className="form">
		                    		<label>{i18next.t("encoding": "encoding")}</label>
		                    		<div className="form-check-inline">
			                            <label className="form-check-label" style={{marginLeft: "7px"}}>
			                                <input className="form-check-input" value="UTF-16LE" type="radio" checked={this.props.createDSDefaultState.textEncoding === 'UTF-16LE'} onChange={this.textEncodingHendler}/>
			                                <span className="form-check-label">{i18next.t("utf16LeEncoding" : "utf16LeEncoding")}</span>
			                            </label>
			                            <label className="form-check-label" style={{marginLeft: "7px"}}>
			                                <input className="form-check-input" value="UTF-8" type="radio" checked={this.props.createDSDefaultState.textEncoding === 'UTF-8'} onChange={this.textEncodingHendler} />
			                                <span className="form-check-label">{i18next.t("utf8Encoding" : "utf8Encoding")}</span>
			                            </label>
				                    </div>
		                    	</div>
			                    {
			                    	this.props.defaultState.duplicateSign && this.props.defaultState.signatureType === "attached" 
			                    	? null
			                    	: <div>
			                    		<label>{i18next.t("ds:textForDsTitle": "textForDsTitle")}</label>
				                        <div className="input-group mb-4">
											<textarea id="dscTextForDs" rows="5" className="form-control" value={this.props.createDSDefaultState.textForDS} onInput={this.textInputHendler}></textarea>
										</div>

										<label>{i18next.t("ds:metaDataFileForDsTitle": "metaDataFileForDsTitle")}</label>
				                        <div className="input-group mb-4">
											<input id="dscMetaDataFileForDs" type="text" className="form-control" value={this.props.createDSDefaultState.textForDSDescription} onInput={this.handleDescriptionChange} />
										</div>
			                    	</div>
			                    }
		                    	
								{
									this.props.defaultState.duplicateSign
										? <div>
											<label>{i18next.t("ds:previsionDsBase64Title": "previsionDsBase64Title")}</label>
					                        <div className="input-group mb-4">
												<textarea id="dscTextForDs" rows="5" value={this.props.createDSDefaultState.previsionDsText} onInput={this.handlePrevisionChange} className="form-control"></textarea>
											</div>
										</div> : null
								}
								<button className="btn btn-default" onClick={this.createDS.bind(this)} disabled={!isTextDSEnabled}>{i18next.t("ds:createDs": "createDs")}
									{
		                                this.state.isLoading ? <span>&nbsp;<i className="fa fa-spinner fa-pulse"></i></span>
		                                : null
		                            }
								</button>
								<button className="btn btn-default" style={{marginLeft: "7px"}} onClick={this.cleanUpForm.bind(this)}>{i18next.t("cleanUpForm": "cleanUpForm")}</button>
		                       
		                        <div style={{"paddingTop": "15px"}}>
									<label>{i18next.t("ds:dscBase64Title": "dscBase64Title")}</label>
									<textarea id="dscDsBase64" rows="5" className="form-control" value={this.props.createDSDefaultState.dsDataInBase64} readOnly> </textarea>
								</div>
		                    </div>
	                    </div>
	                </div>
                </div>
			</div>
		);
	}
}

function mapStateToProps(state) {
    return {
        language: state.localesReducer.language,
        localesReducer: state.localesReducer,
        pkLocalState: state.privateKeyReducer,
        defaultState: state.createDSOptionsReducer,
        createDSDefaultState: state.createDSTextReducer,
        connectionStatus: state.connectionStatusReucer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
	    createSession,
		sendInputData,
		sendSessionMetaData,
		sendSessionOption,
		sendKeyContainer,
		createDS,
		getDSResult,
		deleteSession,
		setInputTextForDS,
		setInputDescription,
		clearInputFileForDS,
		clearInputDescription,
		setDSData,
		clearDSData,
		sendDSData,
		setPrevisionDsFile,
		clearPrevisionDsFile,
		sendTokenPath,
		setDSEncodingType,
		StringToUTF16LEArray,
		fromByteArray,
		StringToArray,
		clearInputTextForDS,
		setInputTextForDSDescription,
		setInputTextForDSUintArr,
		setDSDataBase64,
		clearDSDataBase64,
		clearDSInputTextDescription,
		setPrevisionDsText,
		toByteArray,
		clearPrevisionDsText
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateTextDSContainer);


// WEBPACK FOOTER //
// ./src/containers/CreateTextDSContainer.js